import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ridango-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit, OnChanges {
    @Input() size = '460';
    @Input() visible = false;
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    @HostListener('document:keydown', ['$event'])
    onKeydownHandler(event: KeyboardEvent) {
        if (!this.visible) {
            return;
        }

        if (event.key === 'Escape' || event.key === 'Esc') {
            this.close();
        }
    }

    private popStateHandler = () => {
        if (!this.visible) {
            return;
        }
        history.pushState(null, document.title, window.location.href);
    };

    ngOnInit(): void {
        if (this.visible) {
            this.enableBackButtonTrapping();
        }
    }

    ngOnChanges(): void {
        if (this.visible) {
            this.enableBackButtonTrapping();
        } else {
            this.disableBackButtonTrapping();
        }
    }

    close() {
        this.onClose.emit();
        this.disableBackButtonTrapping();
    }

    private enableBackButtonTrapping() {
        history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', this.popStateHandler);
    }

    private disableBackButtonTrapping() {
        window.removeEventListener('popstate', this.popStateHandler);
    }
}
